export const ANSWERS = [
  "CRANE",
  "PLANT",
  "SHARE",
  "BRAVE",
  "LIGHT",
  "STONE",
  "MIRTH",
  "GLIDE",
  "WOVEN",
  "FROST",
  "CLOUD",
  "TRACE",
  "SPARK",
  "UNITY",
  "RIVER",
  "CHARM",
  "BLEND",
  "QUEST",
  "NOBLE",
  "VIVID",
  "HONEY",
  "LATCH",
  "MANGO",
  "PRISM",
  "SWIFT",
  "THORN",
  "VAULT",
  "YEARN",
  "ZESTY",
  "SOLAR"
];

const EXTRA_GUESSES = [
  "ABOUT",
  "ABOVE",
  "ABUSE",
  "ACTOR",
  "ACUTE",
  "ADMIT",
  "ADOPT",
  "ADORE",
  "AFTER",
  "AGAIN",
  "AGILE",
  "ALERT",
  "ALIKE",
  "ALIVE",
  "ALLOW",
  "ALTER",
  "AMBER",
  "AMONG",
  "ANGER",
  "ANGLE",
  "APART",
  "APPLE",
  "APPLY",
  "ARENA",
  "ARGUE",
  "ARISE",
  "ARRAY",
  "ASIDE",
  "AUDIO",
  "AVOID",
  "AWAKE",
  "BASIC",
  "BEACH",
  "BEGAN",
  "BEGIN",
  "BEING",
  "BELLY",
  "BENCH",
  "BERRY",
  "BIRTH",
  "BLACK",
  "BLADE",
  "BLAME",
  "BLANK",
  "BLAST",
  "BLOCK",
  "BOARD",
  "BOOST",
  "BRAIN",
  "BRAND",
  "BREAD",
  "BREAK",
  "BRICK",
  "BRING",
  "BROAD",
  "BROKE",
  "BROWN",
  "BUILD",
  "CANDY",
  "CARRY",
  "CAUSE",
  "CHAIN",
  "CHAIR",
  "CHART",
  "CHASE",
  "CHEAP",
  "CHECK",
  "CHEER",
  "CHEST",
  "CHIEF",
  "CHILD",
  "CHOIR",
  "CLAIM",
  "CLASS",
  "CLEAN",
  "CLEAR",
  "CLERK",
  "CLICK",
  "CLIMB",
  "CLOCK",
  "COACH",
  "COAST",
  "COLOR",
  "COMET",
  "COUNT",
  "COURT",
  "COVER",
  "CRAFT",
  "CRASH",
  "CREAM",
  "CROWN",
  "DANCE",
  "DEPTH",
  "DOUBT",
  "DRAFT",
  "DREAM",
  "DRIVE",
  "EARLY",
  "EARTH",
  "ELDER",
  "ELITE",
  "ENJOY",
  "ENTER",
  "EQUAL",
  "ERROR",
  "EVENT",
  "EVERY",
  "EXACT",
  "FAITH",
  "FALSE",
  "FANCY",
  "FAULT",
  "FIELD",
  "FINAL",
  "FIRST",
  "FLAME",
  "FLOOR",
  "FOCUS",
  "FORCE",
  "FRAME",
  "FRESH",
  "FRONT",
  "FRUIT",
  "GIANT",
  "GRACE",
  "GRADE",
  "GRAND",
  "GRANT",
  "GRASS",
  "GREAT",
  "GREEN",
  "GROUP",
  "GROWL",
  "GUARD",
  "GUEST",
  "GUIDE",
  "HAPPY",
  "HEART",
  "HEAVY",
  "HORSE",
  "HOUSE",
  "HUMAN",
  "IMAGE",
  "INDEX",
  "INNER",
  "ISSUE",
  "JOINT",
  "JUDGE",
  "JUICE",
  "KNIFE",
  "KNOWN",
  "LARGE",
  "LASER",
  "LAYER",
  "LEARN",
  "LEAST",
  "LEVEL",
  "LIMIT",
  "LOCAL",
  "LODGE",
  "LOGIC",
  "LUCKY",
  "LUNCH",
  "MAGIC",
  "MAJOR",
  "MAPLE",
  "MARCH",
  "MATCH",
  "MAYBE",
  "METAL",
  "MODEL",
  "MONEY",
  "MONTH",
  "MORAL",
  "MOUNT",
  "MOUSE",
  "MOUTH",
  "MUSIC",
  "NERVE",
  "NIGHT",
  "NORTH",
  "OCEAN",
  "OFFER",
  "ORDER",
  "OTHER",
  "PAINT",
  "PANEL",
  "PARTY",
  "PEACE",
  "PHASE",
  "PHONE",
  "PIANO",
  "PIECE",
  "PILOT",
  "PITCH",
  "PLACE",
  "PLAIN",
  "PLANE",
  "POINT",
  "POWER",
  "PRESS",
  "PRICE",
  "PRIDE",
  "PRIME",
  "PRINT",
  "PROOF",
  "PROUD",
  "QUEEN",
  "QUICK",
  "QUIET",
  "RADIO",
  "RAISE",
  "RANGE",
  "REACH",
  "READY",
  "RIGHT",
  "ROUGH",
  "ROUND",
  "ROUTE",
  "ROYAL",
  "SCALE",
  "SCENE",
  "SCORE",
  "SENSE",
  "SERVE",
  "SHADE",
  "SHELF",
  "SHIFT",
  "SHINE",
  "SHIRT",
  "SHORT",
  "SIGHT",
  "SILLY",
  "SINCE",
  "SKILL",
  "SLEEP",
  "SLIDE",
  "SMALL",
  "SMART",
  "SMILE",
  "SOLID",
  "SOUND",
  "SOUTH",
  "SPACE",
  "SPEED",
  "SPEND",
  "SPORT",
  "STAFF",
  "STAGE",
  "STAIR",
  "STAND",
  "START",
  "STATE",
  "STEAM",
  "STEEL",
  "STICK",
  "STILL",
  "STOCK",
  "STORE",
  "STORM",
  "STORY",
  "STUDY",
  "STYLE",
  "SUGAR",
  "SUNNY",
  "TABLE",
  "TEACH",
  "THANK",
  "THEME",
  "THERE",
  "THICK",
  "THING",
  "THINK",
  "THREE",
  "TIGER",
  "TITLE",
  "TODAY",
  "TOUCH",
  "TOWER",
  "TRACK",
  "TRADE",
  "TRAIN",
  "TRIAL",
  "TRUST",
  "TRUTH",
  "UNDER",
  "UPPER",
  "VALUE",
  "VIDEO",
  "VISIT",
  "VOICE",
  "WASTE",
  "WATCH",
  "WATER",
  "WHEEL",
  "WHERE",
  "WHILE",
  "WHITE",
  "WHOLE",
  "WORLD",
  "WORTH",
  "WRITE",
  "YOUNG"
];

export const VALID_GUESSES = new Set([...ANSWERS, ...EXTRA_GUESSES]);
